import { enrichMultiOutcomeOptions } from '@/constants/multi-outcome-ui.js';

export function enrichFeedCardsForDisplay(cards) {
  return cards.map((card) => {
    let next = card;
    if (card?.variant === 'multi' && card.multiOptions?.length) {
      next = {
        ...next,
        multiOptions: enrichMultiOutcomeOptions(card.multiOptions),
      };
    }
    if (card?.multiMarketRows?.length) {
      next = {
        ...next,
        multiMarketRows: card.multiMarketRows.map((row) => ({
          ...row,
          multiOptions: enrichMultiOutcomeOptions(row.multiOptions || []),
        })),
      };
    }
    return next;
  });
}
